import React from "react";
import { Page } from "../../../activities/AppPage";
import { API } from "../../../API";
import { STRINGS } from "../../../strings";
import { AppCaregiver } from "../../../system/AppState/AppCaregiverState";
import { translate } from "../../../translate";
import ScaffoldTitle from "../../Scaffold/components/ScaffoldTitle";
import Scaffold from "../../Scaffold/Scaffold";
import ChatMainActivity from "./ChatMainActivity";

type Props = {
  api: API;
  caregiver: AppCaregiver;
  onRequestNavigate: (page: Page) => void;
  onRequestGoBack: () => void;
};

export default function ChatActivity(props: Props) {
  return (
    <Scaffold
      title={<ScaffoldTitle label={translate(STRINGS.CHAT)} />}
      onClickGoBack={props.onRequestGoBack}
    >
      <ChatMainActivity
        api={props.api}
        caregiver={props.caregiver}
        onClickChatWithOtherAgencies={() => props.onRequestNavigate({ type: "OtherAgenciesChat" })}
        onRequestNavigate={props.onRequestNavigate}
      />
    </Scaffold>
  );
}
